import { bool, func, oneOf, string } from 'prop-types';

import * as criterias from 'atg/constants/CouponCriteria';
import Button from 'shared/components/button/Button';
import ChevronDown from 'shared/components/icon/ChevronDown';
import UrlSharer from 'shared/components/UrlSharer';
import * as Text from 'shared/utils/Text';

const startedTextMap = {
  [criterias.ALL]: 'dialog-coupons-all',
  [criterias.CORRECT_ONLY]: 'dialog-coupons-potential-correct-only',
  [criterias.MAX_ONE_ERROR]: 'dialog-coupons-potential-max-one-error',
  [criterias.MAX_TWO_ERRORS]: 'dialog-coupons-potential-max-two-errors',
};

const completeTextMap = {
  [criterias.ALL]: 'dialog-coupons-all',
  [criterias.CORRECT_ONLY]: 'dialog-coupons-correct-only',
  [criterias.MAX_ONE_ERROR]: 'dialog-coupons-max-one-error',
  [criterias.MAX_TWO_ERRORS]: 'dialog-coupons-max-two-errors',
};

const CouponsResult = ({
  criteria,
  downloadUrl,
  onBackClick,
  betResultStarted,
  betResultComplete,
}) => {
  const mailBody = Text.get('email-body-share', downloadUrl);

  let pdfLinkText;
  if (betResultComplete) {
    pdfLinkText = Text.get(
      'dialog-coupons-open-pdf',
      Text.get(completeTextMap[criteria]),
    );
  } else if (betResultStarted) {
    pdfLinkText = Text.get(
      'dialog-coupons-open-pdf',
      Text.get(startedTextMap[criteria]),
    );
  } else {
    pdfLinkText = Text.get('dialog-coupons-open-pdf-no-criteria');
  }

  return (
    <div className="dialog-coupons-result">
      {betResultComplete && (
        <>
          <Button className="back-button" onClick={onBackClick}>
            <span className="chevron-wrapper">
              <ChevronDown />
            </span>
            {Text.get('dialog-coupons-change-criteria')}
          </Button>

          <hr />
        </>
      )}

      <UrlSharer
        url={downloadUrl}
        mailBody={mailBody}
        isPdf
        pdfLinkText={pdfLinkText}
      />
    </div>
  );
};

CouponsResult.propTypes = {
  criteria: oneOf([
    criterias.ALL,
    criterias.CORRECT_ONLY,
    criterias.MAX_ONE_ERROR,
    criterias.MAX_TWO_ERRORS,
  ]).isRequired,
  onBackClick: func.isRequired,
  downloadUrl: string,
  betResultComplete: bool.isRequired,
};

export default CouponsResult;
